define.alias("ember-cli-string-helpers/helpers/humanize", "media/helpers/humanize");